import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberNotificationSettingsKey } from '../../utils/keys';
export const useMemberNotificationSettings = (options = {}) => {
    const { variables, fields = 'basic', useQueryOptions } = options || {};
    const { client } = useTribeClient();
    return useQuery(getMemberNotificationSettingsKey({ variables, fields }), () => client.query({
        name: 'memberNotificationSettings',
        args: {
            fields,
            variables,
        },
    }), useQueryOptions);
};
//# sourceMappingURL=useMemberNotificationSettings.js.map